import * as React from "react";

import "./analytics-map.scss";

import { AnalyticsMapControl } from "@Common/ui-components/heavy/analytics/analytics-map/analytics-map-control";
import { popupContent }        from "../american-pie-chart/american-pie-chart";

export const AnalyticsMap = ({ leadInteractions, zipCodes }) => {
    const [hoveredContent, setHoveredContent] = React.useState(null);
    const shapes = zipCodes?.filter(zip => !!zip.polygon).map((zip) => {
        const interactionsCount = leadInteractions
            .filter(li => String(li.zip) === String(zip.zipCode)).length;
        return {
            name: zip.zipCode,
            elementKey: zip.zipCode,
            count: zip.count,
            interactions: interactionsCount,
            color: !!zip.count ? "#249AF3" : "#99A0A7",
            vertexList: zip.polygon,
            opacity: .1 + (zip.count/10),
            onMouseOver: () => setHoveredContent(popupContent({title:zip.zipCode, interactionsCount, leadCount: zip.count})),
            onMouseOut : () => setHoveredContent(null),
        }
    })
    const pills = zipCodes?.filter(zip => !!zip.polygon).map((zip) => {
        const interactionsCount = leadInteractions
            .filter(li => String(li.zip) === String(zip.zipCode))
            .reduce((sum, li) => sum + (li.interactions?.length || 0), 0);
        return {
            elementKey: zip.zipCode + "pill",
            count: zip.count,
            position: zip.center,
            onMouseOver: () => setHoveredContent(popupContent({title:zip.zipCode, interactionsCount, leadCount: zip.count})),
            onMouseOut : () => setHoveredContent(null),
        }
    })
    return (
        <div className="analytics-map-af5">
            {AnalyticsMapControl({
                center: [37, -111],
                hoveredContent,
                viewSize: "md",
                shapes,
                pills,
            })}
        </div>
    );
};
